import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFlipBackward = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 21 21",
	fill: "none",
	stroke: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3 8.29134H14.25C16.3211 8.29134 18 9.97027 18 12.0413C18 14.1124 16.3211 15.7913 14.25 15.7913H10.5M3 8.29134L6.33333 4.95801M3 8.29134L6.33333 11.6247",
		strokeWidth: 1.66667,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgFlipBackward;
